/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cd_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It recalculates from the real clock each second, so when you return the numbers are correct even if the tab was backgrounded.`)
};

const es_cd_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recalcula a partir del reloj real cada segundo, así que cuando vuelvas los números serán correctos aunque la pestaña haya estado en segundo plano.`)
};

const de_cd_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es berechnet jede Sekunde neu anhand der tatsächlichen Uhrzeit, sodass die Werte auch dann korrekt sind, wenn der Tab im Hintergrund war.`)
};

const nl_cd_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hij berekent elke seconde opnieuw op basis van de echte klok, dus als je terugkomt kloppen de cijfers, ook als het tabblad op de achtergrond stond.`)
};

const fr_cd_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il recalcule à partir de l'horloge réelle chaque seconde, donc à votre retour les chiffres sont corrects même si l'onglet était en arrière-plan.`)
};

const it_cd_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ricalcola dall'orologio reale ogni secondo, quindi quando torni i numeri sono corretti anche se la scheda era in background.`)
};

const pt_br2_cd_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ela recalcula a partir do relógio real a cada segundo, então quando você voltar os números estarão corretos mesmo que a aba tenha ficado em segundo plano.`)
};

const pt_cd_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recalcula a partir do relógio real a cada segundo, por isso, quando voltar, os números estão corretos mesmo que o separador tenha estado em segundo plano.`)
};

const ja_cd_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1秒ごとに実際の時計から再計算されるため、タブがバックグラウンドになっていても戻ってきたときの数値は正確です。`)
};

const zh_cd_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`它每秒都会根据真实时钟重新计算，因此即使标签页在后台运行，返回时数字依然是正确的。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cd_faq_a3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cd_faq_a3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cd_faq_a3", locale)
	if (locale === "en") return en_cd_faq_a3(inputs)
	if (locale === "es") return es_cd_faq_a3(inputs)
	if (locale === "de") return de_cd_faq_a3(inputs)
	if (locale === "nl") return nl_cd_faq_a3(inputs)
	if (locale === "fr") return fr_cd_faq_a3(inputs)
	if (locale === "it") return it_cd_faq_a3(inputs)
	if (locale === "pt-BR") return pt_br2_cd_faq_a3(inputs)
	if (locale === "pt") return pt_cd_faq_a3(inputs)
	if (locale === "ja") return ja_cd_faq_a3(inputs)
	return zh_cd_faq_a3(inputs)
};